import React, { useState } from "react";
import "./TPT.css";
import html2pdf from "html2pdf.js";
import Quote from "../components/Quote";

const TPT = () => {
  const [thickness, setThickness] = useState(null); // Thickness
  const [ID, setID] = useState(""); // Inner Diameter
  const [OD, setOD] = useState(""); // Outer Diameter
  const [height, setHeight] = useState(""); // Height
  const [rate, setRate] = useState(44);
  const [Wt, setWt] = useState(null); // Weight
  const [Qty, setQty] = useState(""); // Quantity
  const [result, setResult] = useState(null);

  const handleCalculate = () => {
    // Parse inputs to ensure valid numeric values
    const parsedID = parseFloat(ID);
    const parsedOD = parseFloat(OD);
    const parsedHeight = parseFloat(height);
    const parsedQty = parseFloat(Qty);
    const parsedWt = parseFloat(Wt);
    let calculatedThickness = parseFloat(thickness);
    let calculatedWt = parsedWt;

    try {
      // Case 1: Calculate thickness if ID and OD are provided
      if (!calculatedThickness && parsedID && parsedOD) {
        calculatedThickness = parsedOD - parsedID;
        setThickness(calculatedThickness.toFixed(2));
      }

      // Case 2: Calculate weight if ID, height, and thickness are provided
      if (!calculatedWt && parsedID && parsedHeight && calculatedThickness) {
        calculatedWt = (parsedID * parsedHeight * calculatedThickness) / 385;
        setWt(calculatedWt.toFixed(2));
      }

      // Case 3: Calculate thickness if Wt, ID, and height are provided
      if (!calculatedThickness && parsedWt && parsedID && parsedHeight) {
        calculatedThickness = (parsedWt * 385) / (parsedID * parsedHeight);
        setThickness(calculatedThickness.toFixed(2));
      }
      // Set the price as rate * calculated weight
      const calculatedPrice = (rate * calculatedWt) / 1000;

      const result = {
        description: `Core Paper Tube of (${ID}x${parsedHeight}x${calculatedThickness.toFixed(
          2
        )}x${calculatedWt.toFixed(2)}Grm) mm`,
        thickness: calculatedThickness,
        weight: calculatedWt,
        id: parsedID,
        od: parsedOD,
        height: parsedHeight,
        qty: parsedQty,
        price: parseFloat(calculatedPrice.toFixed(2)), // Ensure price is a number
      };

      // Log the result data
      console.log(result);

      // Set the result state with the correct data
      setResult(result);
      setThickness(null);
      setID("");
      setOD("");
      setHeight("");
      setWt(null);
      setQty("");
    } catch (error) {
      console.error("Calculation error:", error);
      setResult("Invalid input or calculation error.");
    }
  };
  const handleDownload = () => {
    // Select the HTML element to convert
    const element = document.getElementById("report");

    // Convert and download PDF
    const options = {
      margin: 1,
      filename: "Quote-GD.pdf",
      html2canvas: { scale: 2 },
      jsPDF: {
        orientation: "portrait", // Keeps the orientation as portrait
        unit: "mm", // Set units to millimeters for better precision
        format: "a4", // You can set other formats like "letter" if needed
        autoSize: true, // Automatically adjust size based on content
      },
    };

    html2pdf().set(options).from(element).save();
  };

  return (
    <div className="container">
      <div className="sv_section-title">
        <h2>Core Paper Tube Cost</h2>
      </div>

      <div className="row justify-content-center">
        <div className="box-calculator">
          {/* Input Fields */}
          <div className="form-group-row">
            <div className="form-group">
              <label>Thickness:</label>
              <input
                type="number"
                value={thickness ?? ""}
                placeholder="Thickness in mm"
                onChange={(e) =>
                  setThickness(parseFloat(e.target.value) || null)
                }
                disabled={(ID && OD) || Wt} // Disable when ID & OD or Wt are filled
                className={(ID && OD) || Wt ? "disabled-input" : ""}
              />
            </div>

            <div className="form-group">
              <label>Inner Diameter (I.D):</label>
              <input
                type="number"
                value={ID}
                placeholder="ID in mm"
                onChange={(e) => setID(e.target.value)}
              />
            </div>

            <div className="form-group">
              <label>Outer Diameter (O.D):</label>
              <input
                type="number"
                value={OD}
                placeholder="OD in mm"
                onChange={(e) => setOD(e.target.value)}
                disabled={thickness} // Disable when Thickness is filled
                className={thickness ? "disabled-input" : ""}
              />
            </div>
          </div>

          <div className="form-group-row">
            <div className="form-group">
              <label>Height (H):</label>
              <input
                type="number"
                value={height}
                placeholder="Height in mm"
                onChange={(e) => setHeight(e.target.value)}
              />
            </div>

            <div className="form-group">
              <label>Wt.:</label>
              <input
                type="number"
                value={Wt ?? ""}
                placeholder="Weight in grams"
                onChange={(e) => setWt(parseFloat(e.target.value) || null)}
                disabled={thickness} // Disable when Thickness is filled
                className={thickness ? "disabled-input" : ""}
              />
            </div>
          </div>

          <div className="form-group-row">
            <div className="form-group">
              <label>Quantity:</label>
              <input
                type="number"
                value={Qty}
                placeholder="Quantity"
                onChange={(e) => setQty(e.target.value)}
              />
            </div>
            <div className="form-group">
              <label>Rate:</label>
              <input
                type="number"
                value={rate}
                placeholder="rate"
                onChange={(e) => setRate(e.target.value)}
              />
            </div>
          </div>

          {/* Calculate Button */}
          <button
            onClick={handleCalculate}
            className="btn-primary w-100 mt-3 mb-3"
          >
            Calculate
          </button>

          {/* Results */}
          {result !== null && (
            <div>
              {/* Download PDF Button */}
              <button
                onClick={handleDownload}
                className="btn-primary w-100 mt-3 mb-3" // Add bottom margin to create space between buttons
              >
                Download PDF
              </button>

              {/* Hidden or visible report content */}
              <div style={{ marginTop: "20px" }}>
                {" "}
                {/* Add top margin to create space above the Quote */}
                <Quote
                  description={result.description}
                  qty={result.qty}
                  rate={result.price} // This is now a number
                  weightAfterWastage={result.weight}
                  type="Tube"
                />
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default TPT;
